(() => {
  if (window.BFEKindnessBundleLoaded) return;
  window.BFEKindnessBundleLoaded = true;

  const updateImage = (scope, productType, finish) => {
    const normalized = finish.toLowerCase();
    const image = scope.querySelector(`[data-bfe-bundle-image="${productType}"]`);
    const next = image?.dataset[`${normalized}Src`];
    if (image && next && image.src !== next) {
      image.src = next;
      image.alt = image.alt.replace(/ in (Gold|Silver)$/i, ` in ${finish}`);
    }

    const selector = scope.querySelector(`[data-bfe-bundle-finish="${productType}"]`);
    const label = selector?.querySelector('[data-bfe-bundle-finish-label]');
    if (label) label.textContent = finish;

    const galleryImage = document.querySelector(`[data-bfe-bundle-gallery-${productType}]`);
    const galleryNext = galleryImage?.dataset[`${normalized}Src`];
    if (galleryImage && galleryNext) {
      galleryImage.src = galleryNext;
      galleryImage.alt = galleryImage.alt.replace(/ in (Gold|Silver)$/i, ` in ${finish}`);
    }
  };

  const optionLabel = (input) => {
    if (!input) return '';
    const explicit = input.id
      ? document.querySelector(`label[for="${CSS.escape(input.id)}"]`)
      : null;
    return explicit?.textContent?.trim()
      || input.closest('label')?.textContent?.trim()
      || input.getAttribute('aria-label')
      || '';
  };

  document.addEventListener('change', (event) => {
    const finishInput = event.target.closest('[data-bfe-bundle-finish] input[type="radio"]');
    if (finishInput) {
      const scope = finishInput.closest('.product-info') || document;
      const productType = finishInput.closest('[data-bfe-bundle-finish]').dataset.bfeBundleFinish;
      updateImage(scope, productType, finishInput.value);
      return;
    }

    const optionInput = event.target.closest('variant-picker input[type="radio"]');
    if (!optionInput) return;

    const optionName = optionLabel(optionInput);
    const scope = optionInput.closest('.product-info') || document;
    const image = scope.querySelector('[data-bfe-bundle-image="tshirt"]');
    const galleryImage = document.querySelector('[data-bfe-bundle-gallery-image]');
    const normalized = optionInput.value === galleryImage?.dataset.whiteOptionId ? 'white'
      : optionInput.value === galleryImage?.dataset.blackOptionId ? 'black' : null;
    if (!normalized) return;

    if (image) {
      const next = image.dataset[`${normalized}Src`];
      if (next) image.src = next;
    }

    if (galleryImage) {
      const next = galleryImage.dataset[`${normalized}Src`];
      if (next) {
        galleryImage.src = next;
        galleryImage.alt = `T-Shirt of Kindness in ${optionName}`;
      }
    }
  });

  document.addEventListener('click', (event) => {
    const thumb = event.target.closest('[data-bfe-bundle-gallery-thumb]');
    if (!thumb) return;

    const gallery = thumb.closest('[data-bfe-kindness-gallery]');
    const overview = gallery?.querySelector('[data-bfe-bundle-gallery-overview]');
    const photo = gallery?.querySelector('[data-bfe-bundle-gallery-photo]');
    if (!gallery || !overview || !photo) return;

    const isOverview = thumb.dataset.bfeBundleGalleryThumb === 'overview';
    overview.hidden = !isOverview;
    photo.hidden = isOverview;

    if (!isOverview && thumb.dataset.photoSrc) {
      photo.src = thumb.dataset.photoSrc;
      photo.alt = thumb.dataset.photoAlt || 'Kindness Bundle';
    }

    gallery.querySelectorAll('[data-bfe-bundle-gallery-thumb]').forEach((button) => {
      const active = button === thumb;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-current', active ? 'true' : 'false');
    });
  });
})();
